import {useCallback, useContext} from 'react';

import {
    NO_ACCOUNT_NAME,
    NO_ACCOUNT_TEMPLATE_USER,
    NO_COUNTRY,
    VALIDATION_ERRORS,
} from 'src/components/account-information/constants';
import {ValidationContext} from 'src/contexts/validation-context';

import type {ValidationContextType} from 'src/contexts/validation-context';
import type {AccountDetails} from 'src/modules/create-account/typedef';

export const useValidateAccountDetails = () => {
    const {addError, clearErrors} = useContext<ValidationContextType>(ValidationContext);

    const validateUnfilled = useCallback((accountDetails: AccountDetails) => {
        let valid = true;

        if (!accountDetails.accountName) {
            addError({
                code: NO_ACCOUNT_NAME,
                message: VALIDATION_ERRORS.NO_ACCOUNT_NAME,
                controlId: 'account-name',
            });
            valid = false;
        }

        if (!accountDetails.templateUser) {
            addError({
                code: NO_ACCOUNT_TEMPLATE_USER,
                message: VALIDATION_ERRORS.NO_ACCOUNT_TEMPLATE_USER,
                controlId: 'account-template-user',
            });
            valid = false;
        }

        if (!accountDetails.countryCode) {
            addError({
                code: NO_COUNTRY,
                message: VALIDATION_ERRORS.NO_COUNTRY,
                controlId: 'account-country-select',
            });
            valid = false;
        }

        return valid;
    }, [addError]);

    return {validateUnfilled, clearErrors};
};
